import * as React from 'react';

export class Screen extends React.Component {
    
    constructor() {
        super();
        
        this.Mobile = false;
        this.screenWidth = this.getWidth();
        
        this.resize = this.resize.bind(this);
        this.isMobile = this.isMobile.bind(this);
    }
    
    resize() {
        this.screenWidth = this.getWidth();
        // console.log( this.screenWidth );
        
        if( this.screenWidth >= 1024 ){ this.Mobile = false; }
        else { this.Mobile = true; }
    }
    
    isMobile(){ return this.Mobile; }
    getWidth(){ return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); }
    
    componentDidMount() { this.resize(); }
}

export default Screen;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/Screen.js